module.exports = __webpack_public_path__ + "img/pr-4.33e9b4dc.png";